import React, { useState, useEffect } from 'react';
import './App.css';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Carousel } from 'react-responsive-carousel';
import NavBar from './navBar';
import Footer from './footer';
import CardWithLeftLine from './cardWithLeftLine';
import FinancialIndependenceJourney from './financialIndependenceJourney';
import StyledList from './StyledList';
import { Box, Typography, Container, Grid,TextField, Button, Divider } from '@mui/material';
import ReCAPTCHA from 'react-google-recaptcha';
import PartnerLogosCarousel from './partnerLogosCarousel';
import { motion } from 'framer-motion';

function App() {
  const [captchaAnswer, setCaptchaAnswer] = useState(null);

  // Form Submit Handler
  const handleSubmitCallBck = async (payload) => {
      const formData = {
        name: payload.name,
        email: payload.email,
        message: payload.message
      };

      const response = await fetch('https://fko3zwfm5f.execute-api.us-east-1.amazonaws.com/dev', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();
      if (response.status === 200) {
        alert('Message sent successfully!');
      } else {
        alert('Error sending message: ' + data.message);
      }
  };

  return (
    <div>
      <NavBar /> 
      <FinanceCarousel />
      <Divider sx={{ marginBottom: 3 }} /> {/* Divider with margin */}
      <AboutUs />
      <Divider sx={{ marginBottom: 3 }} /> {/* Divider with margin */}
      <Services />
      <Divider sx={{ marginBottom: 3 }} /> {/* Divider with margin */}
      <PartnerLogosCarousel />
      <Divider sx={{ marginBottom: 3 }} /> {/* Divider with margin */}
      <PartnerWith />
      <Divider sx={{ marginBottom: 3 }} /> {/* Divider with margin */}
      <ContactForm handleSubmit={(payload) => handleSubmitCallBck(payload)} />
      <Footer/>
      {/* <Footer /> */}
    </div>
  );
}

const FinanceCarousel = () => {
  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
      <Carousel 
        autoPlay={true} 
        dynamicHeight={false} 
        showThumbs={false} 
        sx={{
          width: '100%', // Makes the carousel take up full width
          height: 'auto', // Maintain natural height based on content
        }}
      >
        <div>
          <img 
            src="/health-insurance-2.jpg" 
            alt="Health-Insurance" 
            style={{
              width: '100%',
              height: 'auto',
              objectFit: 'cover', // Ensures the image covers the space without distorting
            }}
          />
          <p className="legend">Secure the best health insurance for yourself today.</p>
        </div>
        <div>
          <img 
            src="/manage-expense.jpg" 
            alt="Manage-Expense" 
            style={{
              width: '100%',
              height: 'auto',
              objectFit: 'cover', // Ensures the image covers the space without distorting
            }}
          />
          <p className="legend">Optimize your expenses for key areas like your car, home, education, retirement, and more.</p>
        </div>
        <div>
          <img 
            src="/life-insurance.jpg" 
            alt="Life Insurance" 
            style={{
              width: '100%',
              height: 'auto',
              objectFit: 'cover', // Ensures the image covers the space without distorting
            }}
          />
          <p className="legend">Have you secured your life insurance yet? If not, get it now with the best benefits tailored to your age.</p>
        </div>
        <div>
          <img 
            src="/invest.jpg" 
            alt="Invest" 
            style={{
              width: '100%',
              height: 'auto',
              objectFit: 'cover', // Ensures the image covers the space without distorting
            }}
          />
          <p className="legend">Allow us to assist you in achieving the good returns from the market.</p>
        </div>
        <div>
          <img 
            src="/invest-on-time.jpg" 
            alt="Invest on time" 
            style={{
              width: '100%',
              height: 'auto',
              objectFit: 'cover', // Ensures the image covers the space without distorting
            }}
          />
          <p className="legend">Maximize your returns from the market by investing at the right time, giving you the best chance for higher margins.</p>
        </div>
        <div>
          <img 
            src="/stock-report.jpg" 
            alt="Stock Report" 
            style={{
              width: '100%',
              height: 'auto',
              objectFit: 'cover', // Ensures the image covers the space without distorting
            }}
          />
          <p className="legend">Allow us to assist you in achieving the good returns from the market.</p>
        </div>
      </Carousel>
    </div>
  );
};


const AboutUs = () => (
  <section id="about">
    <Box sx={{ backgroundColor: 'white', py: 8 }}>
      <Container>
        <Typography 
                  variant="h4" 
                  component="h2" 
                  sx={{
                    fontWeight: 'bold', 
                    color: '#333', 
                    mb: 2, 
                    textAlign: { xs: 'center', md: 'left' }
                  }}
                >
                  About Us
          </Typography>
        <Typography sx={{
                    fontSize: '1.1rem',
                    color: '#555',
                    lineHeight: 1.8,
                    textAlign: { xs: 'center', md: 'left' }
                  }} >
                  At Vantage Finserv, we believe that financial success starts with trust, transparency, and a
          commitment to exceptional customer service. As a leading provider of financial services, we are
          dedicated to helping individuals and businesses navigate their financial journey with confidence
          and clarity.
        </Typography>
        <Typography 
                  variant="h5" align="center" gutterBottom 
                  sx={{
                    color: '#333', 
                    mb: 2, 
                    textAlign: { xs: 'center', },
                    marginTop: 1,
                  }}
                >
                  Our Mission
          </Typography>
        <Typography sx={{
                    fontSize: '1.1rem',
                    color: '#555',
                    lineHeight: 1.8,
                    textAlign: { xs: 'center', md: 'left' }
                  }} >
                  Our mission is to empower our clients with tailored financial solutions that drive
growth and stability. We strive to simplify complex financial landscapes and provide clear,
strategic guidance that aligns with our clients&#39; long-term goals.
        </Typography>
        <Typography 
                 variant="h5" align="center" gutterBottom 
                  sx={{
                    color: '#333', 
                    mb: 2, 
                    textAlign: { xs: 'center'},
                    marginTop: 1
                  }}
                >
                  Why Choose Us
          </Typography>
        <Typography sx={{
                    fontSize: '1.1rem',
                    color: '#555',
                    lineHeight: 1.8,
                    textAlign: { xs: 'center', md: 'left' }
                  }} >
               <StyledList/>
        </Typography>
<FinancialIndependenceJourney />

    </Container>
    </Box>
  </section>
);
const PartnerWith = () => {
  <section id="partner-with">
     <Box sx={{ backgroundColor: '#f4f4f9', py: 8 }}>
      <Container>
      <Typography 
              variant="h4" 
              component="h2" 
              sx={{
                fontWeight: 'bold', 
                color: '#333', 
                mb: 2, 
                textAlign: { xs: 'center', md: 'left' }
              }}
            >
              Partner with Vantage Finserv
            </Typography>
            <Typography sx={{
                    fontSize: '1.1rem',
                    color: '#555',
                    lineHeight: 1.8,
                    textAlign: { xs: 'center', md: 'left' }
                  }} >Join hands with a financial partner who values your success as much as you do. At Vantage Finserv, we are committed to being a trusted advisor on your financial journey, ensuring that every decision you make is backed by expertise and integrity.
                  Let’s build a prosperous future together.
        </Typography>
        </Container>
        </Box>
  </section>
}
const Services = () => (
  <section id="services">
       
      <Box sx={{ backgroundColor: '#f4f4f9', py: 8 }}>
      <Container>
      <Typography 
              variant="h4" 
              component="h2" 
              sx={{
                fontWeight: 'bold', 
                color: '#333', 
                mb: 2, 
                textAlign: { xs: 'center', md: 'left' }
              }}
            >
              Our Services
            </Typography>
            <Typography sx={{
                    fontSize: '1.1rem',
                    color: '#555',
                    lineHeight: 1.8,
                    textAlign: { xs: 'center', md: 'left' }
                  }} >From Insurance & Investment management to Real estate consulting & Loan Services, Vantage Finserv offers a comprehensive suite of financial services designed to meet diverse needs. Our experienced professionals leverage industry insights and innovative strategies to deliver results that matter.
        </Typography>
      <Grid
        container
        spacing={4}
        direction="row"
        justifyContent="center"
        alignItems="flex-start"
      >
  <Grid item xs={12} sm={6} md={4} lg={3}>
    <CardWithLeftLine title={"Insurance Solutions"} 
    body={"Protect what matters most with tailored insurance plans. We offer coverage options designed to provide peace of mind"}
    bulletPoints={["Life Insurance", "Health Insurance" ]}
    icon={"shield"}
    />
  </Grid>

  <Grid item xs={12} sm={6} md={4} lg={3}>
    <CardWithLeftLine title={"Loan Services"} 
      body={"For all your loan requests we have variety of options to choose from, we will help you get the best deal from the market."}
      bulletPoints={["Home Loans", "Education Loans", "Personal Loan", "Auto Loans", "Gold Loans", "Mortgage Loans" ]}
      icon={"loan"}
      />
  </Grid>

  <Grid item xs={12} sm={6} md={4} lg={3}>
  <CardWithLeftLine title={"Financial & Investment Planning"} 
      body={"Create a roadmap for your financial future with our comprehensive planning services. We help you identify your goals and design strategies to achieve them."}
      bulletPoints={["Retirement Planning", "Portfolio Analysis", "Diversified Investment Options", "Mutual fund Investments" ]}
      icon={"investment"}
      />
  </Grid>

  <Grid item xs={12} sm={6} md={4} lg={3}>
  <CardWithLeftLine title={"Real Estate Consulting"} 
      body={"Buy / Sale / Rent Properties."}
      icon={"home"}

      />
  </Grid>
  </Grid>
  </Container>
  </Box>
  </section>
);

const ContactForm = ({ handleSubmit }) => {
  const [recaptchaValue, setRecaptchaValue] = useState(null);
  const googleSiteKey = "6Ldm5MYqAAAAANhW2fUzHlKz7fGJ0rC33GeIxPTU"
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleRecaptchaChange = (value) => {
    setRecaptchaValue(value);
  };
  const onSubmit = (e) => {
    e.preventDefault();
    
    if (!recaptchaValue) {
      alert('Please complete the reCAPTCHA');
      return;
    }

    handleSubmit(formData);
  };

  return (
    <section id="contact">
    <Box
      sx={{
        maxWidth: 600,
        margin: '0 auto',
        padding: 4,
        borderRadius: 6,
        boxShadow: 3,
        backgroundColor: '#f4f4f9',
        py: 8,
        '&:hover': {
          boxShadow: 6, // Add shadow effect on hover for some interactivity
        },
      }}
    >
      <Container>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          <Typography variant="h4" align="center" sx={{ mb: 4, fontWeight: 600, color: '#333' }}>
            Contact Us
          </Typography>

          <form id="contactForm" onSubmit={onSubmit}>
            {/* Full Name */}
            <TextField
              label="Full Name"
              id="name"
              name="name"
              variant="outlined"
              value={formData.name}
              onChange={handleFormChange}
              fullWidth
              required
              sx={{
                mb: 3,
                '& .MuiInputBase-root': {
                  borderRadius: '8px', // Rounded corners for inputs
                  backgroundColor: '#fff',
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#ddd', // Custom border color
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#2980b9', // Border color on hover
                },
              }}
            />

            {/* Email */}
            <TextField
              label="Email"
              id="email"
              variant="outlined"
              value={formData.email}
              onChange={handleFormChange}
              type="email"
              name='email'
              fullWidth
              required
              sx={{
                mb: 3,
                '& .MuiInputBase-root': {
                  borderRadius: '8px',
                  backgroundColor: '#fff',
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#ddd',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#2980b9',
                },
              }}
            />

            {/* Message */}
            <TextField
              label="Message"
              id="message"
              variant="outlined"
              multiline
              name='message'
              value={formData.message}
              onChange={handleFormChange}
              rows={4}
              fullWidth
              required
              sx={{
                mb: 3,
                '& .MuiInputBase-root': {
                  borderRadius: '8px',
                  backgroundColor: '#fff',
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#ddd',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#2980b9',
                },
              }}
            />

            {/* Captcha */}
            <Box sx={{ mb: 3 }}>
              <ReCAPTCHA
                sitekey={googleSiteKey} // Replace with your site key
                onChange={handleRecaptchaChange}
              />
            </Box>

            {/* Submit Button */}
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              sx={{
                mt: 2,
                py: 2,
                fontSize: '1rem',
                backgroundColor: '#2980b9',
                '&:hover': {
                  backgroundColor: '#1d6f8c',
                },
              }}
            >
              Send Message
            </Button>
          </form>
        </motion.div>
      </Container>
    </Box>
  </section>
  )};


export default App;
